import { TenantEntity } from '../TenantEntity'

export class CarForm extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'CarForm'
  }

  get carFormNo() {
    return this._data.carFormNo
  }
  set carFormNo(carFormNo) {
    this._data.carFormNo = carFormNo
  }

  get carryingCmp() {
    return this._data.carryingCmp
  }
  set carryingCmp(carryingCmp) {
    this._data.carryingCmp = carryingCmp
  }

  get plateNumber() {
    return this._data.plateNumber
  }
  set plateNumber(plateNumber) {
    this._data.plateNumber = plateNumber
  }

  get driverName() {
    return this._data.driverName
  }
  set driverName(driverName) {
    this._data.driverName = driverName
  }

  get driverPhone() {
    return this._data.driverPhone
  }
  set driverPhone(driverPhone) {
    this._data.driverPhone = driverPhone
  }

  get driverIdCard() {
    return this._data.driverIdCard
  }
  set driverIdCard(driverIdCard) {
    this._data.driverIdCard = driverIdCard
  }

  get departureDate() {
    return this._data.departureDate
  }
  set departureDate(departureDate) {
    this._data.departureDate = departureDate
  }

  get finishedDate() {
    return this._data.finishedDate
  }
  set finishedDate(finishedDate) {
    this._data.finishedDate = finishedDate
  }

  get destination() {
    return this._data.destination
  }
  set destination(destination) {
    this._data.destination = destination
  }

  get status() {
    return this._data.status
  }
  set status(status) {
    this._data.status = status
  }

  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
}
